import { Component, OnInit, SystemJsNgModuleLoader } from '@angular/core';
import { LoginService } from '../login/login.service';
import { ReporteDocumentoService } from './reporte.documento.service';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'contabilidad-electronica-cmp',
    templateUrl: 'contabilidad-electronica.component.html',
    providers: [ReporteDocumentoService,LoginService,DatePipe]
})

export class ContabilidadElectronicaComponent implements OnInit {

  public mes: number;
  public ano: number;
  public anos: any[] = [];
  public tipo: String;
  public cuentas_sin_agrupador: number = 0;
  public obligar_asignar_agrupador: boolean = false;
  rfc: any;
  public fecha: String;
  criteriaSearch: any;
  public num: String;
  public tipoP: String;

  cargarAnos() {
    const ejercicios = JSON.parse(localStorage.getItem('ejercicios'));
    for (let x = 0; x < ejercicios.length ; x++) {
      this.anos.push(ejercicios[x].anio);
    }
    this.ano = this.anos[this.anos.length - 1];
  }
  cargarEmpresa() {
          this.rfc = this.loginService.usuario.empresa_seleccionada.rfc;
    }
  exportBalanzaComprobacionXML(): void {
    this.mostrarMensajeCarga('Se está generando tu reporte');
    this.reporteDocumentoService.getRepBalCompXml(this.loginService.empresa, this.tipo, 
      this.mes, this.ano, this.fecha, this.rfc).subscribe(response => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(response);
      const fechaActual = new Date();
      a.download = this.rfc + this.ano
      + (this.mes < 10 ? '0' + this.mes : this.mes) + 'B' + this.tipo + '.zip';
      document.body.appendChild(a);
      a.click();
      this.cerrarMensajeCarga();
    }, err => {
    this.cerrarMensajeCarga();
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  exportPolizasPeriodoXML(): void {
    this.mostrarMensajeCarga('Se está generando tu reporte');
    console.log(this.fecha);
    this.reporteDocumentoService.getRepPolPerXml(this.loginService.empresa, this.mes, this.ano, this.tipoP,
      this.num.replace('/', '-').toUpperCase(), this.rfc).subscribe(response => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(response);
      const fechaActual = new Date();
      a.download = this.rfc + this.ano
      + (this.mes < 10 ? '0' + this.mes : this.mes) + 'PL.zip';
      document.body.appendChild(a);
      a.click();
      this.cerrarMensajeCarga();
    }, err => {
    this.cerrarMensajeCarga();
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'No existen polizas para exportar al xml';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  exportAuxCtasXML(): void {
    this.mostrarMensajeCarga('Se está generando tu reporte');
    console.log(this.fecha);
    this.reporteDocumentoService.getRepAuxMovXml(this.loginService.empresa, this.mes, this.ano, this.tipoP,
      this.num.replace('/', '-').toUpperCase(), this.rfc).subscribe(response => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(response);
      const fechaActual = new Date();
      a.download = this.rfc + this.ano
      + (this.mes < 10 ? '0' + this.mes : this.mes) + 'XC.zip';
      document.body.appendChild(a);
      a.click();
      this.cerrarMensajeCarga();
    }, err => {
    this.cerrarMensajeCarga();
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'No existen polizas para exportar al xml';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  exportAuxFoliosXML(): void {
    this.mostrarMensajeCarga('Se está generando tu reporte');
    console.log(this.fecha);
    this.reporteDocumentoService.getRepAuxFolXml(this.loginService.empresa, this.mes, this.ano, this.tipoP,
      this.num.replace('/', '-').toUpperCase(), this.rfc).subscribe(response => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(response);
      const fechaActual = new Date();
      a.download = this.rfc + this.ano
      + (this.mes < 10 ? '0' + this.mes : this.mes) + 'XF.zip';
      document.body.appendChild(a);
      a.click();
      this.cerrarMensajeCarga();
    }, err => {
    this.cerrarMensajeCarga();
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'No existen polizas para exportar al xml';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  exportCtbCtaXml(): void {
    this.mostrarMensajeCarga('Se está generando tu reporte');
    this.cargarEmpresa();
    this.reporteDocumentoService.getRepCueConXml(this.loginService.empresa, 0, this.rfc).subscribe(response => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(response);
      const fechaActual = new Date();
      a.download = this.rfc + fechaActual.getFullYear()
      + (fechaActual.getMonth() < 10 ? '0' + fechaActual.getMonth() : fechaActual.getMonth()) + (fechaActual.getMonth() + 1) + 'CT.zip';
      document.body.appendChild(a);
      a.click();
      this.cerrarMensajeCarga();
    }, err => {
    this.cerrarMensajeCarga();
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  constructor(private loginService: LoginService, private reporteDocumentoService: ReporteDocumentoService, 
    public datepipe: DatePipe) {
  }
    ngOnInit() {
      this.getInfoAgrupador();
      this.num = '';
      this.tipoP = 'AF';
    this.criteriaSearch = {};
      this.cargarEmpresa();
      this.fecha = new Date().toISOString().substring(0, 10);
      this.mes = 1;
      this.cargarAnos();
      this.tipo = 'N';
        $('[data-toggle="collapse-hover"]').each(function () {
            var thisdiv = $(this).attr("data-target");
            $(thisdiv).addClass("collapse-hover");
        });

        $('[data-toggle="collapse-hover"]').hover(function(){
            var thisdiv = $(this).attr("data-target");
            if(!$(this).hasClass('state-open')){
                $(this).addClass('state-hover');
                $(thisdiv).css({
                    'height':'30px'
                });
            }

        },
        function(){
            var thisdiv = $(this).attr("data-target");
            $(this).removeClass('state-hover');

            if(!$(this).hasClass('state-open')){
                $(thisdiv).css({
                    'height':'0px'
                });
            }
        }).click(function(event){
            event.preventDefault();

            var thisdiv = $(this).attr("data-target");
            var height = $(thisdiv).children('.panel-body').height();

            if($(this).hasClass('state-open')){
                $(thisdiv).css({
                    'height':'0px',
                });
                $(this).removeClass('state-open');
            } else {
                $(thisdiv).css({
                    'height':height + 30,
                });
                $(this).addClass('state-open');
            }
        });
    }
    getInfoAgrupador(): void {
      this.reporteDocumentoService.getInfoAgrupador(this.loginService.empresa)
      .subscribe(response => {

        this.cuentas_sin_agrupador = response.contenido.cuentas_sin_agrupador;
        this.obligar_asignar_agrupador = response.contenido.obligar_asignar_agrupador;
        if(this.obligar_asignar_agrupador == true && this.cuentas_sin_agrupador>0){
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: 'Se ha deshabilitado el apartado de cuentas contables debido a que '+ this.cuentas_sin_agrupador + ' registros no cuentan con agrupador del SAT'
          })

        } else if(this.obligar_asignar_agrupador == false) {
          Swal.fire({
            icon: 'info',
            title: 'TNK Ledger',
            text: 'Se ha deshabilitado el apartado de cuentas contables debido a que no se obliga asignar agrupador del SAT'
          })
        }
      }, err => {
      this.cerrarMensajeCarga();
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
        console.log(err);
      });
    }
    mostrarMensajeCarga(mensaje: string) {
      const numeros = [1, 2, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6];
      const aleatorio = numeros[Math.floor(Math.random() * numeros.length)];
      Swal.fire({
        html: `
        <div style="text-align: center">
          <h4><img src="/assets/gif/loading` + aleatorio + `.gif" width="80"/>
          <br><br><strong>Por favor espere...</strong><br><small>` + mensaje + `</small></h4>
        </div>`,
        toast: false,
        allowOutsideClick: false,
        showConfirmButton: false,
      });
    }
    cerrarMensajeCarga() {
      Swal.close();
    }
}
